import { PROMOTIONS_URL } from 'constants/config';
import { fetchJson } from 'utils/fetchJson/fetchJson';

export const promotions = {
  subscribe: (senderEmail: string) => {
    const payload = {
      email: senderEmail,
    };
    const body = JSON.stringify(payload);
    const options = { body, method: 'POST' };

    return fetchJson<void>(PROMOTIONS_URL, options);
  },
};
